import React, { useRef, useState, useEffect } from 'react';
import { Button, Icon, Box } from '@material-ui/core';
import { get, isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import SectionTabs from './SectionTabs';
import SectionSettingsDrawer from './SectionSettingsDrawer';
import { TableMapActionsProps } from './types';

const TableMapActions = ({ sections, activeSectionId, setActiveSectionId, onCreatePlace }: TableMapActionsProps) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [dispalaySettings, setDispalaySettings] = useState<boolean>(false);
    const [drawerOffset, setDrawerOffset] = useState<number>(0);
    const [t] = useTranslation();

    const { current: buttonEl } = buttonRef;
    useEffect(() => {
        if(buttonEl) {
            const { offsetTop } = buttonEl;
            const offset = offsetTop;
            setDrawerOffset(offset);
        }
    }, [buttonEl, setDrawerOffset]);
    const openSectionSettings = () => setDispalaySettings(true);
    const closeSectionSettings = () => setDispalaySettings(false);
    const activeSection = get(activeSectionId, sections);
    const handleCreateClick = async () => onCreatePlace({ id: activeSection.id, name: activeSection.name });
    return (
        <Box display='flex' justifyContent='space-between' pt={6} px={6} alignItems='flex-start'>
            <Button
                variant="contained"
                color="primary"
                onClick={handleCreateClick}
            >
                {t('Create table')}
            </Button>
            {!isEmpty(sections) ? (
                <SectionTabs
                    sections={sections}
                    active={activeSectionId}
                    setActive={setActiveSectionId}
                />
            ) : null}
            <Button
                component='button'
                color="primary"
                onClick={openSectionSettings}
                endIcon={<Icon>settings</Icon>}
                ref={buttonRef}
            >
                {t('section settings')}
            </Button>
            <SectionSettingsDrawer
                isOpen={dispalaySettings}
                close={closeSectionSettings}
                offset={drawerOffset}
            />
        </Box>
    );
};

export default TableMapActions;
